import { createLogic } from "redux-logic";
import { type TradeInTrackingParamsType, trackFinishedSearch } from "../../utils/tracking";
import {
    type TradeInAemFindVehicleSetResults,
    TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_RESULTS,
} from "../actions/TradeInAemFindVehicleActions";
import type { TradeInAemLogicType } from "../store";
import { getTradeInCsl } from "../../csl/tradeInCslUtils";
import { TradeInAemFindVehicleStatus } from "../../utils/types";

const setResultsLogic = (createLogic as TradeInAemLogicType<TradeInAemFindVehicleSetResults>)({
    type: [TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_RESULTS],
    process({ getState, action }, _, done) {
        const { searchResults, status } = action;
        const { commonSettings, tradeInAemUtils, tradeInAemFindVehicle, tradeInAemDealer } = getState();
        const { country, language, brand } = commonSettings;
        const { version, parentComponent } = tradeInAemUtils;
        const { dealer } = tradeInAemDealer;
        const csl = getTradeInCsl(brand, country, language, version);
        const trackingParams: TradeInTrackingParamsType = { csl, dealer, tradeInVersion: version, parentComponent };

        let state: "found" | "notfound" | "error" | undefined;

        if (searchResults.length) state = "found";
        else if (!status && !searchResults.length) state = "notfound";
        else if (status === TradeInAemFindVehicleStatus.Failed) state = "error";

        if (state) trackFinishedSearch(trackingParams, tradeInAemFindVehicle.searchType, state);
        done();
    },
});

export default [setResultsLogic];
